module.exports = __webpack_public_path__ + "static/media/MZ_05.d9cd0344.jpg";